'use client';

import Header from '@/components/common/Header';
import HeroSection from './HeroSection';
import WhatIsSection from './WhatIsSection';
import ValuePropositionSection from './ValuePropositionSection';
import RelevanceSection from './RelevanceSection';
import DimensionsSection from './DimensionsSection';
import AudienceSection from './AudienceSection';
import FinalCTASection from './FinalCTASection';
import FooterSection from './FooterSection';

export default function LandingPageInteractive() {
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#FFFFFF' }}>
      <Header />
      <main className="flex-1">
        <HeroSection />
        <WhatIsSection />
        <ValuePropositionSection />
        <RelevanceSection />
        <DimensionsSection />
        <AudienceSection />
        <FinalCTASection />
      </main>
      <FooterSection />
    </div>
  );
}